import { render, staticRenderFns } from "./pdf_h5.vue?vue&type=template&id=86ffc664&scoped=true&"
import script from "./pdf_h5.vue?vue&type=script&lang=js&"
export * from "./pdf_h5.vue?vue&type=script&lang=js&"
import style0 from "./pdf_h5.vue?vue&type=style&index=0&id=86ffc664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ffc664",
  null
  
)

export default component.exports